import { createSlice } from '@reduxjs/toolkit';
import { createThunkHttp } from '../../services/helpers/thunk';

import {
  httpGetCalendarEvents,
} from '../../services/http';
import { calendarAdaptor } from '../../services/helpers/calendar.adaptor';

export const selectCalendarEvents = (state) => state.calendarEvents.calendarEvents;
export const selectCalendarEventsLoading = (state) => state.calendarEvents.isLoading;

// Thunks
export const getCalendarEvents = createThunkHttp(
  'calendarEvents/getCalendarEvents',
  httpGetCalendarEvents,
);

export const calendarEventsSlice = createSlice({
  name: 'calendarEvents',
  initialState: {
    calendarEvents: [],
    isLoading: false,
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCalendarEvents.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(getCalendarEvents.fulfilled, (state, action) => ({
        ...state,
        isLoading: false,
        calendarEvents: calendarAdaptor(action.payload.results),
      }))
      .addCase(getCalendarEvents.rejected, (state) => ({
        ...state,
        isLoading: false,
      }));
  },
});

export default calendarEventsSlice.reducer;
